import { cva } from 'class-variance-authority';

export const carouselContentVariants = cva('flex', {
  variants: {},
  defaultVariants: {},
});

export const carouselItemVariants = cva('min-w-0 shrink-0 grow-0', {
  variants: {},
  defaultVariants: {},
});
